<div #wrapper class="ngx-ie-image-wrapper" [ngClass]="wrapper_classes" [ngStyle]="wrapper_styles">  
  <img *ngIf="ready" [src]="final_src" class="ngx-ie-image" [ngClass]="image_classes" [ngStyle]="image_styles" [alt]="alt" [attr.width]="image_width" [attr.height]="image_height" [style.object-fit]="image_fit"/>
</div>
